import Image from 'next/image';
import { FC } from 'react';
import { useFormContext } from '../../../../../../contexts/FormContext';
import { CardButtons } from '../CardButtons';
import Markdown from 'markdown-to-jsx';
import styles from './FacebookCard.module.css';

type FacebookCardProps = {
  responseIndex: number;
  text: string;
  id: string;
};

export const FacebookCard: FC<FacebookCardProps> = ({
  text,
  responseIndex,
  id,
}) => {
  const { socialInput } = useFormContext();
  const { personaSocialInput } = useFormContext();

  // Custom H1 component that adds a '#' at the beginning
  const CustomH1: React.FC<{ children: string }> = ({ children, ...props }) => (
    <b {...props}>#{children}</b>
  );

  const CustomMarkdown: React.FC<{ children: string }> = ({ children }) => {
    return (
      <Markdown
        options={{
          overrides: {
            h1: {
              component: CustomH1,
            },
          },
        }}
      >
        {children}
      </Markdown>
    );
  };

  if (!socialInput) return null;

  return (
    <div className={styles['container']}>
      <div className={styles['header-container']}>
        <div className={styles['avatar']} />
        <div className={styles['handle-container']}>
          <p>
            <b>{socialInput.companyName || personaSocialInput?.brand}</b>
          </p>
          <div className={styles['info']}>
            <p>15m • </p>
            <Image
              src="/icons/PlanetEarthClear.svg"
              alt=""
              layout="fixed"
              objectFit="contain"
              height={9}
              width={9}
            />
          </div>
        </div>
      </div>
      {/* <p className={styles['response-text']}>{text}</p> */}
      <CustomMarkdown>{text}</CustomMarkdown>
      <CardButtons responseIndex={responseIndex} id={id} />
    </div>
  );
};
